import React from "react";
import PropTypes from "prop-types";
import { Link, useStaticQuery, graphql } from "gatsby";
import { HeaderDiv, HeaderShim, MenuDiv } from "./elements";
import HeaderImage from "./../../images/nus-icon.png";
import makeSlug from "./../../modules/makeSlug";

const makeSections = (data) => {
  const themes = [];
  const locations = [];
  const sectionsMemo = [];
  for (let i = 0; i < data.length; i++) {
    const thisOne = data[i].data;
    if (thisOne.Section) {
      for (let j = 0; j < thisOne.Section.length; j++) {
        if (sectionsMemo.indexOf(thisOne.Section[j]) < 0) {
          sectionsMemo.push(thisOne.Section[j]);
          if (thisOne.Section[j].indexOf("Region: ") > -1) {
            locations.push({
              name: thisOne.Section[j].split("Region: ")[1],
              slug: `/section/${makeSlug(thisOne.Section[j])}`,
            });
          } else {
            themes.push({
              name: thisOne.Section[j],
              slug: `/section/${makeSlug(thisOne.Section[j])}`,
            });
          }
        }
      }
    }
  }
  return { themes, locations };
};

const Header = ({ siteTitle, isHome }) => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [dropDownShown, setDropDownShown] = React.useState(false);
  const [dropDownValue, setDropDownValue] = React.useState(false);

  const sectionQuery = useStaticQuery(graphql`
    {
      allAirtable(filter: { data: { Ready_to_Publish_: { eq: true } } }) {
        nodes {
          data {
            Section
          }
        }
      }
    }
  `).allAirtable.nodes;

  const { locations, themes } = makeSections(sectionQuery);

  const resetDropDowns = (id) => {
    if (dropDownShown && dropDownValue === id) {
      setDropDownShown(false);
      setDropDownValue("");
    } else {
      setDropDownShown(true);
      setDropDownValue(id);
    }
  };

  return (
    <React.Fragment>
      <HeaderDiv menuOpen={menuOpen}>
        <h1>
          {isHome ? (
            <React.Fragment>
              <img src={HeaderImage} alt="NUS Press" />
              <span>{siteTitle}</span>
            </React.Fragment>
          ) : (
            <Link to="/">
              <img src={HeaderImage} alt="NUS Press" />
              <span>{siteTitle}</span>
            </Link>
          )}
        </h1>
        <ul>
          {isHome ? null : (
            <li className="mobile">
              <Link to={`/`}>Home</Link>
            </li>
          )}
          <li>
            <a
              href="/#"
              onClick={(e) => {
                e.preventDefault();
                resetDropDowns("locations");
              }}
            >
              Locations
            </a>
            {dropDownValue === "locations" ? (
              <MenuDiv>
                {locations.map((location, index) => (
                  <li key={index}>
                    <Link to={location.slug}>{location.name}</Link>
                  </li>
                ))}
              </MenuDiv>
            ) : null}
          </li>
          <li>
            <a
              href="/#"
              onClick={(e) => {
                e.preventDefault();
                resetDropDowns("themes");
              }}
            >
              Themes
            </a>
            {dropDownValue === "themes" ? (
              <MenuDiv>
                {themes.map((theme, index) => (
                  <li key={index}>
                    <Link to={theme.slug}>{theme.name}</Link>
                  </li>
                ))}
              </MenuDiv>
            ) : null}
          </li>
          <li>
            <a
              href="/#"
              onClick={(e) => {
                e.preventDefault();
                resetDropDowns("texts");
              }}
            >
              Texts
            </a>
            {dropDownValue === "texts" ? (
              <MenuDiv>
                <li>
                  <Link to={`/visualising`}>Visualising Seaways</Link>
                </li>
                <li>
                  <Link to={`/mining-the-visual-record`}>
                    Mining the Visual Record
                  </Link>
                </li>
                <li>
                  <Link to={`/webandbook`}>Notes on the website</Link>
                </li>
              </MenuDiv>
            ) : null}
          </li>
        </ul>
        <nav>
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(() => !menuOpen);
            }}
          >
            ☰
          </a>
        </nav>
        <div>
          <ul>
            {isHome ? null : (
              <li className="mobile">
                <Link to={`/`}>Home</Link>
              </li>
            )}
            <li>
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  resetDropDowns("locations");
                }}
              >
                Locations
              </a>
              {dropDownValue === "locations" && menuOpen ? (
                <MenuDiv mobile>
                  {locations.map((location, index) => (
                    <li key={index}>
                      <Link to={location.slug}>{location.name}</Link>
                    </li>
                  ))}
                </MenuDiv>
              ) : null}
            </li>
            <li>
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  resetDropDowns("themes");
                }}
              >
                Themes
              </a>
              {dropDownValue === "themes" && menuOpen ? (
                <MenuDiv mobile>
                  {themes.map((theme, index) => (
                    <li key={index}>
                      <Link to={theme.slug}>{theme.name}</Link>
                    </li>
                  ))}
                </MenuDiv>
              ) : null}
            </li>
            <li>
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  resetDropDowns("texts");
                }}
              >
                Texts
              </a>
              {dropDownValue === "texts" && menuOpen ? (
                <MenuDiv mobile>
                  <li>
                    <Link to={`/visualising`}>Visualising Seaways</Link>
                  </li>
                  <li>
                    <Link to={`/mining-the-visual-record`}>
                      Mining the Visual Record
                    </Link>
                  </li>
                  <li>
                    <Link to={`/webandbook`}>Notes on the website</Link>
                  </li>
                </MenuDiv>
              ) : null}
            </li>
          </ul>
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(false);
            }}
          >
            &nbsp;
          </a>
        </div>
      </HeaderDiv>
      <HeaderShim />
    </React.Fragment>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
  isHome: PropTypes.bool,
};

Header.defaultProps = {
  siteTitle: ``,
  isHome: false,
};

export default Header;
